import { Injectable } from '@angular/core';
import { CryptoService } from './crypto.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private cryptoService: CryptoService) { }

  get token() : string | null  {
    return localStorage.getItem("token");
  }

  set token(token: string) {
    localStorage.setItem("token", token);
  }

  get refreshToken() : string | null  {
    return localStorage.getItem("refresh_token");
  }

  set refreshToken(refreshToken: string) {
    localStorage.setItem("refresh_token", refreshToken);
  }

  get firstName() : string | null 
  {
    return localStorage.getItem("firstName") ?? this.cryptoService.getDecodedAccessToken()?.unique_name;
  }

  set firstName(firstName: string)
  {
    localStorage.setItem("firstName", firstName);
  }

  get lastName() : string | null 
  {
    return localStorage.getItem("lastName") ?? this.cryptoService.getDecodedAccessToken()?.given_name;
  }

  set lastName(lastName: string)
  {
    localStorage.setItem("lastName", lastName);
  }

  get email() : string | null 
  {
    return localStorage.getItem("email") ?? this.cryptoService.getDecodedAccessToken()?.email;
  }

  set email(email: string)
  {
    localStorage.setItem("email", email);
  }

  get sportbookUrl() : string | null
  {
    return this.cryptoService.getDecodedAccessToken()?.SportBookProviderToken;
  }

  get loggedIn()
  {
    if(this.token == undefined || this.token == '')
      return false;
    else
      return true;
  }

  get deviceId() : string | null {
    return localStorage.getItem("device_id");
  }

  set deviceId(deviceId: string){
    localStorage.setItem("device_id", deviceId);
  }
}
